<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10.6914 1.81656C10.4743 1.71751 10.2384 1.66626 9.99977 1.66626C9.76111 1.66626 9.52524 1.71751 9.3081 1.81656L2.16643 5.06656C2.01856 5.13176 1.89283 5.23856 1.80457 5.37394C1.71631 5.50932 1.66931 5.66744 1.66931 5.82906C1.66931 5.99067 1.71631 6.1488 1.80457 6.28418C1.89283 6.41956 2.01856 6.52635 2.16643 6.59156L9.31643 9.84989C9.53357 9.94893 9.76944 10.0002 10.0081 10.0002C10.2468 10.0002 10.4826 9.94893 10.6998 9.84989L17.8498 6.59989C17.9976 6.53469 18.1234 6.42789 18.2116 6.29251C18.2999 6.15713 18.3469 5.999 18.3469 5.83739C18.3469 5.67578 18.2999 5.51765 18.2116 5.38227C18.1234 5.24689 17.9976 5.14009 17.8498 5.07489L10.6914 1.81656Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.66687 10C1.66648 10.1594 1.7118 10.3155 1.79747 10.45C1.88314 10.5844 2.00556 10.6914 2.15021 10.7583L9.31687 14.0167C9.53287 14.1145 9.76726 14.1651 10.0044 14.1651C10.2415 14.1651 10.4759 14.1145 10.6919 14.0167L17.8419 10.7667C17.9894 10.7004 18.1144 10.5926 18.2017 10.4564C18.289 10.3203 18.3348 10.1617 18.3335 10"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.66687 14.167C1.66648 14.3264 1.7118 14.4825 1.79747 14.617C1.88314 14.7514 2.00556 14.8584 2.15021 14.9253L9.31687 18.1837C9.53287 18.2815 9.76726 18.3321 10.0044 18.3321C10.2415 18.3321 10.4759 18.2815 10.6919 18.1837L17.8419 14.9337C17.9894 14.8674 18.1144 14.7596 18.2017 14.6234C18.289 14.4873 18.3348 14.3287 18.3335 14.167"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconLayers',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
